import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";

export default class PageMarketingSplash extends Component {
	
	render () {
		
		let block 		= this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="c-m-splash">
			    		
			    		<div className="c-m-splash__image">
			    			{block.src && 
								<FadeIn>
									{onload => (
										<img
											alt={''} 
											src={block.src} 
											srcSet={block.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							}
			    		</div>
			    			
						<p className="c-m-splash__text" style={{fontSize:block.fontsize + 'vw'}} dangerouslySetInnerHTML={{__html:block.text}}></p>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
